import { Injectable } from '@angular/core'
import { HttpInterceptor, HttpEvent, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http'
import { catchError, finalize, Observable, of, switchMap, throwError } from 'rxjs'
import { LoadingService } from '../common/loading.service'
import { CommonService } from '../common/common.service'
import { GlobalConstants } from 'src/app/constants/global-constants'
import { AuthService } from '../auth/auth.service'

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService, private loadingService: LoadingService, private cs: CommonService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.loadingService.show()
    return next.handle(request).pipe(
      finalize(() => {
        this.loadingService.hide()
      }),
      catchError(error => {
        if (error.error?.message == 'Token may have expired. Please renew your session.' && error.status == 401) {
          this.handleTokenRefresh(request, next)
          return of()
        } else {
          if (error instanceof HttpErrorResponse && error.status === 401) {
            this.cs.routeTo(GlobalConstants.ROUTING.LOGIN)
            this.authService.logout()
          }
          return throwError(() => JSON.stringify(error))
        }
      })
    )
  }

  private handleTokenRefresh(request: HttpRequest<any>, next: HttpHandler) {
    return this.authService.refreshToken(request, next)
  }
}
